import { useQuery } from '@pinia/colada';

import showingAgentssService from '../services/showing-agents.service';

export const showingAgentsQueryKey = 'showing-agents';

export function useShowingAgentsQuery(enabled: () => boolean = () => true) {
  return useQuery({
    key: () => [showingAgentsQueryKey],
    enabled,
    query: () => showingAgentssService.getList(),
  });
}
